import { TabId } from '../types';
import { useEffect } from 'react';
import { useTabsProvider } from '../const';

/**
 * Selects the default tab if selected tab is not available
 */
export const useFallbackTab = ({
	activeTab,
	availableTabIds,
	selectHandler,
}: {
	activeTab: TabId;
	availableTabIds: TabId[];
	selectHandler: (nextTabIndex: TabId) => void;
}) => {
	const providerValue = useTabsProvider();
	const fallbackTab = providerValue?.defaultTab || availableTabIds[0];

	useEffect(() => {
		if (!activeTab || availableTabIds.includes(activeTab) || !fallbackTab) {
			return;
		}

		selectHandler(fallbackTab);
	}, [availableTabIds, activeTab, selectHandler, fallbackTab]);
};
